/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import typography from "../../base/typography";
import borders from "../../base/borders";
import colors from "../../base/colors";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "../../functions/pxToRem";

const { size } = typography;
const { text } = colors;
const { borderWidth, borderColor } = borders;

// The glass system: the Dialog paper is the frosted glass FRAME; the content
// sits on a solid WHITE panel inside it (matches the Figma spec). Title/actions
// stay on the glass frame; only this content area is opaque white.
const dialogContent = {
  styleOverrides: {
    root: {
      padding: pxToRem(20),
      margin: `${pxToRem(4)} ${pxToRem(16)} ${pxToRem(16)}`,
      fontSize: size.md,
      color: text.main,
      backgroundColor: "#ffffff",
      borderRadius: pxToRem(14),
    },

    dividers: {
      borderTop: `${borderWidth[1]} solid ${borderColor}`,
      borderBottom: `${borderWidth[1]} solid ${borderColor}`,
    },
  },
};

export default dialogContent;
